var prevArrow = '<a href="#" class="slick-arrow slick-prev" aria-label="Previous"></a>';
var nextArrow = '<a href="#" class="slick-arrow slick-next" aria-label="Next"></a>';

$(window).on('resize load scroll', function () {
  var hh = $("header.header").outerHeight();
  var height = $(window).outerHeight() - hh;
  $(".slider__slide-image").each(function(){
    $(this).css("height", height);
  });
});


$('.js-fullwidth-slidesr').slick(sliderFullwidthItemsConfig);
var sliderThumbsConfig = {
  infinite: false,
  speed: 1000,
  cssEase: 'ease-out',
  prevArrow: prevArrow,
  nextArrow: nextArrow,
  slidesToShow: 8,
  slidesToScroll: 8,
  vertical: true,
  swipe: false
};

